{
  "invoice": {
    "title": "Invoice",
    "bill_to": "Bill to",
    "ship_to": "Ship to",
    "tax_summary": "Tax summary"
  },
  "content_zone": "Content Zone {number}"
}
